import { type HTMLContentType } from '@/common/types/dedicated-personal-page.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export const getPrivacyAndPolicy = async () => {
  const client = new Client();
  return await client.get<HTMLContentType>(
    '/v1/personalpage/Shopper/PrivacyAndPolicy'
  );
};

export const useGetPrivacyAndPolicy = () =>
  useQuery({
    queryFn: getPrivacyAndPolicy,
    queryKey: ['privacy_and_policy'],
  });
